import useTranslation from '@space-core/hooks/useTranslation'
import { customMedia } from '@space-core/styles'

import Section from '@space-shell/common/components/section'
import useRequest from '@space-shell/common/hooks/useRequest'
import type { Progress } from '@space-shell/common/services/product'
import { PageType, ProductEndpoints, ProductService } from '@space-shell/common/services/product'
import { RoleType, useAppStore, useViewAsStore } from '@space-shell/core/store'
import { useParentInfoStore } from '@space-shell/remotes/preview/store/parentInfo'
import { useParams } from 'react-router-dom'

import styled from 'styled-components'

import ErrorState from './errorState'

import ProgressList from './progressList'

type MyProgressProps = {
  title?: string
}

const SectionWrapper = styled(Section)<{ $isPreview: boolean }>`
  margin-bottom: ${({ $isPreview }) =>
    $isPreview ? '0' : 'calc(var(--spacer-10) + var(--spacer-10))'};

  ${customMedia.lessThan('md')`
    margin-bottom: var(--spacer-11);
  `}
`

const MyProgress = ({ title }: MyProgressProps) => {
  const { t } = useTranslation()
  const { membership } = useParams()
  const { role: viewAsRole, isEnabled: isViewAsEnabled } = useViewAsStore()
  const membershipSlug = String(membership)
  const queryKeys = [String(viewAsRole), String(isViewAsEnabled)]
  const { sectionForm } = useParentInfoStore()
  const { isPreview } = useAppStore()

  const {
    isError,
    data = [],
    invalidate
  } = useRequest([ProductEndpoints.progress(membershipSlug), ...queryKeys], () =>
    ProductService.getProgress(membershipSlug)
  )

  let filteredData = data.filter((page: Progress) => page.pageType !== PageType.ADVERTISEMENT)
  const isViewAsALoggedOutUser = isViewAsEnabled && viewAsRole === RoleType.UserLogout

  if (isPreview) {
    filteredData = [{ id: 1 } as Progress, { id: 2 } as Progress]
  }

  if ((!isError && !filteredData?.length) || isViewAsALoggedOutUser) {
    return null
  }
  const getTitle = () => {
    if (sectionForm) {
      return sectionForm.title
    }

    return typeof title === 'string' ? title : t('sections.my_progress.title_v2')
  }

  return (
    <SectionWrapper $isPreview={isPreview} title={getTitle()} className='_px-4 _px-md-10'>
      {isError && !isPreview ? (
        <ErrorState onTryAgain={invalidate} />
      ) : (
        <ProgressList data={filteredData} />
      )}
    </SectionWrapper>
  )
}

export default MyProgress
